"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestFile = exports.request = void 0;
const axios_1 = __importDefault(require("axios"));
const error_1 = require("./error");
const config_1 = require("./config");
const param_1 = require("@/utils/url/param");
async function request(url, config = {}) {
    const { method = "get", params, body, headers, token, ...requestParams } = config;
    const requestHeaders = {
        ...headers,
    };
    if (body && body instanceof FormData) {
        requestHeaders["Content-Type"] = "multipart/form-data";
    }
    const { data, error, headers: responseHeaders, } = await (0, axios_1.default)({
        method,
        url,
        params: token === false
            ? params
            : {
                ...params,
                "access-token": (0, config_1.getToken)(),
            },
        paramsSerializer: (params) => {
            return (0, param_1.params)(params);
        },
        data: body,
        responseType: "json",
        ...requestParams,
    })
        .then((response) => {
        return {
            data: response.data,
            headers: response.headers,
        };
    })
        .catch((error) => {
        return {
            data: error.response.data,
            status: error.response.status,
            error: new error_1.ResponseError(error.response),
        };
    });
    return {
        data: data,
        error,
        headers: responseHeaders,
    };
}
exports.request = request;
async function requestFile(url, config = {}, onDownloadProgress) {
    const { method = "get", params, body, headers, token, ...requestParams } = config;
    const requestHeaders = {
        ...headers,
    };
    if (body && body instanceof FormData) {
        requestHeaders["Content-Type"] = "multipart/form-data";
    }
    const { data, error, headers: responseHeaders, } = await (0, axios_1.default)({
        method,
        url,
        params: token === false
            ? params
            : {
                ...params,
                "access-token": (0, config_1.getToken)(),
            },
        paramsSerializer: (params) => {
            return (0, param_1.params)(params);
        },
        data: body,
        responseType: "blob",
        onDownloadProgress,
        ...requestParams,
    })
        .then((response) => {
        return {
            data: response.data,
            headers: response.headers,
            ...response
        };
    })
        .catch((error) => {
        return {
            data: error.response.data,
            status: error.response.status,
            error: new error_1.ResponseError(error.response),
        };
    });
    return {
        data: data,
        error,
        headers: responseHeaders,
    };
}
exports.requestFile = requestFile;
